/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateTagsControllerAssignTagMutationRequest, TemplateTagsControllerAssignTagMutationResponse, TemplateTagsControllerAssignTag400, TemplateTagsControllerAssignTag401, TemplateTagsControllerAssignTag403, TemplateTagsControllerAssignTag404 } from "../../models/checklistsController/TemplateTagsControllerAssignTag";

function getTemplateTagsControllerAssignTagUrl() {
  const res = { method: 'PUT', url: `/api/v1/checklist-template-tags/assign` as const }  
  return res
}

/**
 * @summary Assign a tag to a template family
 * {@link /api/v1/checklist-template-tags/assign}
 */
export async function templateTagsControllerAssignTag(data?: TemplateTagsControllerAssignTagMutationRequest, config: Partial<RequestConfig<TemplateTagsControllerAssignTagMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateTagsControllerAssignTagMutationResponse, ResponseErrorConfig<TemplateTagsControllerAssignTag400 | TemplateTagsControllerAssignTag401 | TemplateTagsControllerAssignTag403 | TemplateTagsControllerAssignTag404>, TemplateTagsControllerAssignTagMutationRequest>({ method : "PUT", url : getTemplateTagsControllerAssignTagUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}